var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{style:(_vm.$vuetify.breakpoint.smAndDown ? 'max-height:40rem' : ''),attrs:{"src":_vm.link,"title":_vm.title,"frameBorder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }